

































































































import { Vue, Component, Prop } from "@/shared/vuepack";
import { Validator } from "vee-validate";

@Component({})
export default class PasswordSetup extends Vue {
  confirmPassword = "";
  revealPassword = false;
  revealConfirmPassword = false;

  @Prop({ default: "" })
  value: string;

  @Prop({ default: "" })
  doesNotContain: string;

  @Prop()
  validatorOverride: Validator;

  get passwordValidation () {
    return {
      length: [12, 40],
      atLeastOneUppercase: true,
      atLeastOneLowercase: true,
      atLeastOneNumber: true,
      noWhitespace: true,
      doesNotContain: this.doesNotContain
    };
  }

  get confirmPasswordValidation () {
    return {
      required: !!this.value,
      confirmed: !!this.confirmPassword && this.value
    };
  }

  created () {
    if (this.validatorOverride) {
      this.$validator = this.validatorOverride;
    }
  }

  pwReqMet (rule: string, defaultValue = false) {
    if (!this.value) {
      return defaultValue;
    }

    return !this.errors.firstByRule("password", rule);
  }

  onInput (event: Event) {
    const target = event.target as HTMLInputElement;
    this.$emit("input", target.value);
  }

  togglePasswordMask () {
    this.revealPassword = !this.revealPassword;
  }

  toggleConfirmPasswordMask () {
    this.revealConfirmPassword = !this.revealConfirmPassword;
  }
}
